module.exports = __webpack_public_path__ + "static/Wysa-e24e6c37569ff03b2b51cf104ee02546.jpg";